import type { IconIndicatorProps } from "../icon-indicator.type";

import { useTranslation } from "react-i18next";

export const useIconIndicatorTooltip = ({
  type,
  subTypes,
  tooltipFallback,
}: IconIndicatorProps) => {
  const { t } = useTranslation();

  if (!subTypes?.length) {
    return t(`indicator:${type}`, { defaultValue: tooltipFallback?.type });
  }

  if (subTypes.length === 1) {
    const subType = subTypes[0];
    return t(`indicator:${type}:${subType}`, {
      defaultValue: tooltipFallback?.subTypes?.[subType],
    });
  }

  return subTypes.map((subType) =>
    t(`indicator:${type}:${subType}`, {
      defaultValue: tooltipFallback?.subTypes?.[subType],
    })
  );
};
